import { createListenerMiddleware } from '@reduxjs/toolkit'

import { validateFormAction } from './actions'
import { resetAllModifiedDataByKey } from './formSlice'
import { IFormState } from './models'
import { FormValidationBuilder } from './utils/validation'

export const formListenerMiddleware = createListenerMiddleware()

formListenerMiddleware.startListening({
  actionCreator: resetAllModifiedDataByKey,
  effect: (action) => {
    const { payload } = action
    const formValidation = FormValidationBuilder.build(payload)

    formValidation.clear()
  },
})

formListenerMiddleware.startListening({
  actionCreator: validateFormAction,
  effect: (action, listenerApi) => {
    const formKey = action.payload
    const state = listenerApi.getState() as { form: IFormState }
    const formValidation = FormValidationBuilder.build(formKey)

    if (state.form[formKey] && state.form[formKey].formData) {
      const { formData } = state.form[formKey]
      const formFields = Object.entries(formData)
      formFields.forEach(([field, value]) => formValidation.call(field, value))
    }
  },
})
